import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnlineExamStartComponent } from './components/online-exam-start/online-exam-start.component';
import { ExamLobbyInfoComponent } from './components/exam-lobby-info/exam-lobby-info.component';
import { ErrorsModule } from '../../common/errors/errors.module';
import { AttemptModule } from 'form-builder';
import { AttemptOnlineExamComponent } from './components/attempt-online-exam/attempt-online-exam.component';
import { LibConfirmModule } from 'lib-confirm';
import { OnlineExamSuccessComponent } from './components/online-exam-success/online-exam-success.component';

@NgModule({
  declarations: [OnlineExamStartComponent, ExamLobbyInfoComponent, AttemptOnlineExamComponent, OnlineExamSuccessComponent],
  imports: [
    CommonModule,
    ErrorsModule,
    AttemptModule,
    LibConfirmModule
  ]
})
export class OnlineExamModule { }
